import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MessagesModel } from '../../messages/models/MessagesModel';
import { IAppState } from '../store/state/IAppState';
import { AppConfigurationService } from '../services/AppConfigurationService';
import { RootNavigationManager } from '../services/RootNavigationManager';
import { Store, Action } from '@ngrx/store';
import * as fromStore from '../../messages/store/reducers';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'brd-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }
  message: string;
  messages: MessagesModel;
  destroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(private router: Router,
	private rootNavigationManager: RootNavigationManager,
    private appConfigurationService: AppConfigurationService,
    private store: Store<any>,
    private changeDetectorRef: ChangeDetectorRef) {
    this.message = appConfigurationService.configuration.landingPageMessage;    
  }

  ngOnInit() {
    this.store
      .select(fromStore.getMessages)
      .takeUntil(this.destroyed$)
      .subscribe((v: MessagesModel) => {
        if (v) {
          this.messages = v;

          if(!this.hasDisclaimer){
            this.rootNavigationManager.goHome();
          }
        }
        this.changeDetectorRef.markForCheck();
      });
  }

  get hasDisclaimer(): boolean {
    if(this.messages != null && this.messages.activeDisclaimerDescription 
    && this.messages.activeDisclaimerDescription.trim() != ""){
      return true;
    }
    else {
      return false;
    }
  }

  continue() {
    this.rootNavigationManager.goHome();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/landing-page.component.ts